<template>
  <div class="navigate">
    <div class="top-left">
        <a @click='getHome'>
          <h6>首页</h6>
        </a>
    </div>
    <div class="top" v-show='!showLogin'>
        <a @click='getLogin'>
          <h6>登录</h6>
        </a>
    </div>
    <div class="title">
      <h1>王锐的导航页</h1>
    </div>
    <div class="navigate-work" v-for='item in navList' :key='item.id'>
      <h2>{{ item.content }}</h2>
      <div class="navigate-content">
        <a target="_blank" v-for='childItem in item.childList' :key='childItem.id' v-bind:href=childItem.url class="childItem">{{ childItem.content }}</a>
      </div>
    </div>
    <div class='footcontent'>
      <a href="https://beian.miit.gov.cn">网站备案号：鄂ICP备2021021940号</a><br />
      <a href="https://beian.mps.gov.cn">全国互联网安全管理平台</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheFirst',
  data () {
    return {
      msg: 'welcome materials-lab.',
      // 这是登录表单的数据绑定对象
      navList: {
        content: '',
        url: '',
        navLevel: 0,
        parentId: 0,
        priority: 0,
        childList: []
      },
      showLogin: true
    }
  },
  mounted () {},
  created () {
    // 获取导航数据
    this.geNavList()
    this.getshowLogin()
  },
  methods: {
    // 获取导航数据实现
    async geNavList () {
      const { data: res } = await this.$http.post('/navigation/tree', {type: 1})
      if (res.code !== 1) {
        return this.$message.error('获取导航列表失败！')
      }
      this.navList = res.body
    },
    getHome () {
      // 转换为布尔值
      const token = window.sessionStorage.getItem('token')
      if (token !== null) {
        this.$router.push('/home')
        // this.$router.push({ name: 'home', params: { showadmin: true } })
      } else {
        this.$router.push('/login')
        // this.$router.push({ name: 'login', params: { oldName: 'navigation' } })
      }
    },
    getLogin () {
      this.$router.push('/login')
    },
    async getshowLogin () {
      // 转换为布尔值
      const token = window.sessionStorage.getItem('token')
      if (token === null) {
        this.showLogin = false
      }
      console.info('================showLogin : ' + this.showLogin)
    }
  }
}
</script>

<style scoped>
.navigate{
  padding-top: 15px;
  height: 100%;
  background-image: linear-gradient(to bottom right, #a8edea 0%, #fed6e3 100%);
}
.navigate-work{
  position: relative;
  left: 200px;
  margin: 30px;
  width: 75%;
  display: block;
  margin-inline-start: 2px;
  margin-inline-end: 2px;
  padding-block-start: 0.35em;
  padding-inline-start: 0.75em;
  padding-inline-end: 0.75em;
  padding-block-end: 0.625em;
  min-inline-size: min-content;
  border-width: 2px;
  border-style: groove;
  border-color: rgb(192, 192, 192);
  border-image: initial;
}
.navigate-work a{
  margin-top: 15px;
  display: block;
  width: 120px;
  height: 30px;
}
.navigate-work h2{
  text-align: left;
  margin-left: 30px;
  position: relative;
  top: -45px;
}
.navigate-content{
  margin-top: -65px;
  display: flex;
  flex-flow: wrap;
  width: 100%;
}
.top-left{
  width: 100%;
}
.top-left h6{
  width: 100px;
  float: left;
}
.top{
  width: 100%;
}
.top h6{
  width: 100px;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/navigation.vue